import { lazy } from "react";
import { withPageLoader } from "@tecorien/mimic";
import { links } from "links";
import { EntityPageMode, getEntityPathTemplate } from "navigation";
import { Permissions } from "permissions";
import { RouteDescription } from "types";

const FleetListPage = lazy(() => import("./FleetListPage"));
const FleetPage = lazy(() => import("./FleetPage"));

export const fleetsRoutes: RouteDescription[] = [
  {
    path: links.fleet,
    element: withPageLoader(<FleetListPage />),
    breadcrumb: "Fleets",
    menuItem: {
      id: "fleets",
      label: "Fleets",
    }
  },
  {
    path: getEntityPathTemplate(links.fleet),
    element: withPageLoader(<FleetPage />),
    breadcrumb: "Fleet",
    pageModePermissions: {
      [EntityPageMode.edit]: {
        requiredOneOfPermissions: [ Permissions.Admin, Permissions.SuperAdmin ]
      }
    }
  },
];

